export const SET_USER = 'AUTH/SET_USER';
export const LOGIN_START = 'AUTH/LOGIN_START';
export const LOGIN_SUCCESS = 'AUTH/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'AUTH/LOGIN_FAILURE';
export const FORGOT_PASSWORD_START = 'AUTH/FORGOT_PASSWORD_START';
export const FORGOT_PASSWORD_SUCCESS = 'AUTH/FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'AUTH/FORGOT_PASSWORD_FAILURE';
export const RESET_PASSWORD_START = 'AUTH/RESET_PASSWORD_START';
export const RESET_PASSWORD_SUCCESS = 'AUTH/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'AUTH/RESET_PASSWORD_FAILURE';
export const SET_V_ERRORS = 'AUTH/SET_V_ERRORS';
export const SET_V_MESSAGES = 'AUTH/SET_V_MESSAGES';
export const SET_LOADER = 'AUTH/SET_LOADER';
export const LOGOUT = 'AUTH/LOGOUT';
export const SET_FORGOT_DATA = 'AUTH/SET_FORGOT_DATA';
